import templateUrl from './edit-user-account.component.html';
import { IQService, IFormController } from 'angular';
import { EmployeeService } from '../../../core/services';
import { EmployeeModel } from '@herbjoy/apex-api-models';
import { EventEmitter } from '../../../common/components/event-emitter';

/**
 * A component containing an edit form used to register a new user account.
 */
export const EditUserAccountComponent = {
    templateUrl,
    require: {
        editForm: "?^^form"
    },
    bindings: {
        /** The user being created. */
        user: "<?",
        /** Indicates if fields normally only editable by super users can be edited. */
        isSiteAdmin: "<?",
        /** Indicates whether the current user is editing their own account details. */
        isEditingSelf: "<?",
        /**  Indicates if edits are disabled for the user account details */
        isDisabled: "<?",
        change: "&onChange",
        sendPasswordReminder: "&onSendPasswordReminder",
        resendEmailConfirmation: "&onResendEmailConfirmation"
    },
    controller: class EditUserAccountComponent {
        editForm: IFormController;
        user: EmployeeModel;
        isSiteAdmin: boolean;
        isEditingSelf: boolean;
        isDisabled: boolean;
        change: EventEmitter<any>;
        sendPasswordReminder: EventEmitter<any>;
        resendEmailConfirmation: EventEmitter<any>
        originalUserName: string;
        userNamePending: boolean;
        constructor(private $q: IQService, private employeeService: EmployeeService) {
            'ngInject';
        }

        $onInit() {
            if (this.isSiteAdmin === undefined) {
                this.isSiteAdmin = false;
            }

            if (this.isEditingSelf === undefined) {
                this.isEditingSelf = false;
            }

            if (this.isDisabled === undefined) {
                this.isDisabled = false;
            }
        }

        $onChanges(changesObj) {
            if (changesObj.user && this.user) {
                this.originalUserName = this.user.UserName;
            }
        }

        onChangeUserName(userName) {
            this.userNamePending = true;
            this._validateUserNameAvailability(userName)
                .catch(() => { })
                .then(() => this.userNamePending = false)
                .then(() => {
                    if (this.editForm.$valid) {
                        this.change({ $event: this.user });
                    }
                });
        }

        private _validateUserNameAvailability(userName) {
            return this._isEmailAddressAvailable(userName)
                .then(available => this.editForm.UserName
                    .$setValidity("available", available));
        }

        private _isEmailAddressAvailable(userName) {
            if (userName === this.originalUserName) {
                return this.$q.resolve(true);
            }
            return this.employeeService.isEmailAddressAvailable(userName);
        }
    }
};

